import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone } from "react-icons/fi";
import { FaRegEnvelope } from "react-icons/fa6";
import whiteLogo from '../images/white-logo.png';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer py-4">
            <Container className="container-footer">
                {/* Для ПК */}
                <Row className="mb-4 d-none d-lg-flex">
                    <Col lg={4} className="d-flex align-items-center">
                        <div className="footer-logo">
                            <Link to="/">
                                <img
                                    src={whiteLogo}
                                    height="100"
                                    className="d-inline-block"
                                    alt="Перформанс лого"
                                />
                            </Link>
                        </div>
                    </Col>
                    
                    <Col lg={3}>
                        <h5 className="text-uppercase mb-4 font-weight-bold">НАВИГАЦИЯ</h5>
                        <ul className="list-unstyled footer-links">
                            <li className="mb-2">
                                <Link to="/catalog" className="text-white text-decoration-none">КАТАЛОГ</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/about" className="text-white text-decoration-none">О НАС</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/contacts" className="text-white text-decoration-none">КОНТАКТЫ</Link>
                            </li>
                        </ul>
                    </Col>
                    
                    <Col lg={5}>
                        <h5 className="text-uppercase mb-4 font-weight-bold">ОФИС В ТЮМЕНИ</h5>
                        <div className="contact-info">
                            <p className="d-flex align-items-center mb-3">
                                <FiMapPin className="me-3" size={24} />
                                <a 
                                    href="https://yandex.ru/maps/?text=г.+Тюмень,+ул.+Мельничная,+д.+17" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none"
                                >
                                    г. Тюмень, ул. Мельничная 17
                                </a>
                            </p>
                            <p className="d-flex align-items-center mb-3">
                                <FiPhone className="me-3" size={24} />
                                <span>
                                    <a href="tel:+73452614940" className="text-white text-decoration-none">+7 (3452) 61-49-40</a>,{' '}
                                    <a href="tel:+79612149991" className="text-white text-decoration-none">+7 (961) 214-99-91</a>
                                </span>
                            </p>
                            <p className="d-flex align-items-center mb-3">
                                <FaRegEnvelope className="me-3" size={24} />
                                <a 
                                    href="mailto:dos.sreda@yandex.ru" 
                                    className="text-white text-decoration-none"
                                >
                                    dos.sreda@yandex.ru
                                </a>
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Для планшетов */}
                <Row className="mb-4 d-none d-md-flex d-lg-none">
                    <Col md={12} className="text-center mb-4">
                        <div className="footer-logo">
                            <Link to="/">
                                <img
                                    src={whiteLogo}
                                    height="100"
                                    className="d-inline-block"
                                    alt="Перформанс лого"
                                />
                            </Link>
                        </div>
                    </Col>
                    
                    <Col md={6}>
                        <h5 className="text-uppercase mb-4 font-weight-bold">НАВИГАЦИЯ</h5>
                        <ul className="list-unstyled footer-links">
                            <li className="mb-2">
                                <Link to="/catalog" className="text-white text-decoration-none">КАТАЛОГ</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/about" className="text-white text-decoration-none">О НАС</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/contacts" className="text-white text-decoration-none">КОНТАКТЫ</Link>
                            </li>
                        </ul>
                    </Col>
                    
                    <Col md={6}>
                        <h5 className="text-uppercase mb-4 font-weight-bold">ОФИС В ТЮМЕНИ</h5>
                        <div className="contact-info">
                            <p className="d-flex align-items-center mb-3">
                                <FiMapPin className="me-3" size={24} />
                                <a 
                                    href="https://yandex.ru/maps/?text=г.+Тюмень,+ул.+Мельничная,+д.+17" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none"
                                >
                                    г. Тюмень, ул. Мельничная 17
                                </a>
                            </p>
                            <p className="d-flex align-items-center mb-3">
                                <FiPhone className="me-3" size={24} />
                                <span>
                                    <a href="tel:+73452614940" className="text-white text-decoration-none">+7 (3452) 61-49-40</a>,{' '}
                                    <a href="tel:+79612149991" className="text-white text-decoration-none">+7 (961) 214-99-91</a>
                                </span>
                            </p>
                            <p className="d-flex align-items-center mb-3">
                                <FaRegEnvelope className="me-3" size={24} />
                                <a 
                                    href="mailto:dos.sreda@yandex.ru" 
                                    className="text-white text-decoration-none"
                                >
                                    dos.sreda@yandex.ru
                                </a>
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Для телефонов */}
                <Row className="mb-4 d-md-none">
                    <Col xs={12} className="text-center mb-4">
                        <div className="footer-logo">
                            <Link to="/">
                                <img
                                    src={whiteLogo}
                                    height="100"
                                    className="d-inline-block"
                                    alt="Перформанс лого"
                                />
                            </Link>
                        </div>
                    </Col>
                    
                    <Col xs={12} style={{padding: "0 20px"}}>
                        <h5 className="text-uppercase mb-4 font-weight-bold">ОФИС В ТЮМЕНИ</h5>
                        <div className="contact-info">
                            <p className="d-flex align-items-center mb-3">
                                <FiMapPin className="me-3" size={24} />
                                <a 
                                    href="https://yandex.ru/maps/?text=г.+Тюмень,+ул.+Мельничная,+д.+17" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none"
                                >
                                    г. Тюмень, ул. Мельничная 17
                                </a>
                            </p>
                            <p className="d-flex align-items-center mb-3">
                                <FiPhone className="me-3" size={24} />
                                <span>
                                    <a href="tel:+73452614940" className="text-white text-decoration-none">+7 (3452) 61-49-40</a>,{' '}
                                    <a href="tel:+79612149991" className="text-white text-decoration-none">+7 (961) 214-99-91</a>
                                </span>
                            </p>
                            <p className="d-flex align-items-center mb-3">
                                <FaRegEnvelope className="me-3" size={24} />
                                <a 
                                    href="mailto:dos.sreda@yandex.ru" 
                                    className="text-white text-decoration-none"
                                >
                                    dos.sreda@yandex.ru
                                </a>
                            </p>
                        </div>
                    </Col>
                </Row>
                
                <hr className="footer-divider" />
                
                {/* Мобильный ссылки навигации в одну линию */}
                <div className="d-md-none mobile-nav-links">
                    <Row className="text-center">
                        <Col xs={4}>
                            <Link to="/catalog" className="text-white text-decoration-none small">КАТАЛОГ</Link>
                        </Col>
                        <Col xs={4}>
                            <Link to="/about" className="text-white text-decoration-none small">О НАС</Link>
                        </Col>
                        <Col xs={4}>
                            <Link to="/contacts" className="text-white text-decoration-none small">КОНТАКТЫ</Link>
                        </Col>
                    </Row>
                </div>
                
                <div className="text-center copyright mt-4">
                    <p className="mb-0">© 2012-2025 ООО «Перформанс». Все права защищены.</p>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;